export const agentJtbdStatusMapping = (
  t: (key: string) => string,
): Record<string, Record<string, string>> => ({
  completed: {
    emoji: '✅',
    icon: '🎯',
    text: t('conversationShowAgentJtbdCompleted'),
    color: 'success',
    bgColor: 'var(--success-100)',
    textColor: 'var(--success-700)',
  },
  failed: {
    emoji: '❌',
    icon: '⚠️',
    text: t('conversationShowAgentJtbdFailed'),
    color: 'error',
    bgColor: 'var(--danger-100)',
    textColor: 'var(--danger-700)',
  },
})

export const getAgentJtbdStatusDisplay = (
  t: (key: string) => string,
  status: boolean | undefined,
) => {
  return status
    ? agentJtbdStatusMapping(t).completed
    : agentJtbdStatusMapping(t).failed
}
